import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { RateBucketService } from '../rate-bucket.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';


@Component({
    selector: 'app-rate-bucket-copy-form',
    templateUrl: './rate-bucket-copy-form.component.html',
    styleUrls: ['./rate-bucket-copy-form.component.css'],
    standalone: false
})
export class RateBucketCopyFormComponent implements OnInit {
	form1: UntypedFormGroup;
	formLoading = false;
	formErrorMessage;
	rateBucket;

	validationMessages =
		{
			name: [{ type: 'required', message: 'New name is required.' }],
		};

	constructor(
		private formBuilder: UntypedFormBuilder,
		private rateBucketService: RateBucketService,
		private messageService: MessageService,
		public dynamicDialogRef: DynamicDialogRef,
		public dynamicDialogConfig: DynamicDialogConfig
	) { }

	ngOnInit(): void {
		this.rateBucket = this.dynamicDialogConfig?.data?.rateBucket
		this.buildForm();
	}

	onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		this.dynamicDialogRef.close(this.form1.value);
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			rateBucketId: [this.rateBucket.rateBucketId],
			name: ['', Validators.required],
		});
	}
}
